var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNumber } from 'class-validator';
import { Daily7InsuranceFeeDto } from '../../response/fee/daily-7-insurance-fee.dto';
export class CreateDaily7InsuranceFeeDto extends Daily7InsuranceFeeDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day1", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day2", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day3", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day4", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day5", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day6", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateDaily7InsuranceFeeDto.prototype, "day7", void 0);
